/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PortfolioBase } from './PortfolioBase';
import {
    PortfolioBaseFromJSON,
    PortfolioBaseFromJSONTyped,
    PortfolioBaseToJSON,
} from './PortfolioBase';

/**
 * 
 * @export
 * @interface Portfolio
 */
export interface Portfolio {
    /**
     * 
     * @type {PortfolioBase}
     * @memberof Portfolio
     */
    base: PortfolioBase;
}

/**
 * Check if a given object implements the Portfolio interface.
 */
export function instanceOfPortfolio(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "base" in value;

    return isInstance;
}

export function PortfolioFromJSON(json: any): Portfolio {
    return PortfolioFromJSONTyped(json, false);
}

export function PortfolioFromJSONTyped(json: any, ignoreDiscriminator: boolean): Portfolio {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'base': PortfolioBaseFromJSON(json['base']),
    };
}

export function PortfolioToJSON(value?: Portfolio | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'base': PortfolioBaseToJSON(value.base),
    };
}

